// 261010 P8e — dải "Chuẩn bị x/3 — còn thiếu" + chấm tab + gom onActionDone. Không antd ⇒ jest chạy được.
import type { BankPrep, PrepKey } from './bankPrepUtils';
import type { AssetTabKey } from './assetsTabsUtils';

export const PREP_TO_TAB: Record<PrepKey, AssetTabKey> = {
  chars: 'CHARACTERS', locs: 'LOCATIONS', props: 'PROPS',
};

export interface PrepStripItem { tab: AssetTabKey; text: string }
export interface PrepStripView {
  readyText: string;
  allDone: boolean;
  items: PrepStripItem[];
}

export function prepStripView(prep: BankPrep | null): PrepStripView | null {
  if (!prep) return null;
  const items = prep.groups.flatMap((g) => g.missing.map((text) => ({ tab: PREP_TO_TAB[g.key], text })));
  return { readyText: `Chuẩn bị ${prep.done}/3`, allDone: items.length === 0, items };
}

export type TabDotKind = 'ok' | 'warn' | null;
export function tabDotsOf(prep: BankPrep | null): Record<AssetTabKey, TabDotKind> {
  const out: Record<AssetTabKey, TabDotKind> = { CHARACTERS: null, LOCATIONS: null, PROPS: null };
  if (!prep) return out;
  for (const g of prep.groups) out[PREP_TO_TAB[g.key]] = g.done ? 'ok' : 'warn';
  return out;
}

export function createCoalescer(fn: () => void, ms: number): { schedule: () => void; flush: () => void; cancel: () => void } {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const clear = () => { if (timer !== null) { clearTimeout(timer); timer = null; } };
  return {
    schedule: () => { clear(); timer = setTimeout(() => { timer = null; fn(); }, ms); },
    flush: () => { if (timer === null) return; clear(); fn(); },
    cancel: () => { clear(); },
  };
}
